import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { injectIntl, intlShape } from 'react-intl';

class LocationSearchInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = { address: '' };
	}

	handleChange = address => {
		this.setState({ address });
	};

	handleSelect = address => {
		geocodeByAddress(address)
			.then(results => {
				this.setState({ address: results[0].formatted_address });
				getLatLng(results[0]).then(latLng => this.props.onSelectLocation(latLng));
			})
			.catch(error => console.error('Error', error));
	};

	render() {
		return (
			<PlacesAutocomplete value={this.state.address} onChange={this.handleChange} onSelect={this.handleSelect}>
				{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
					<div>
						<input
							{...getInputProps({
								placeholder: this.props.intl.formatMessage({ id: 'common.searchLocation' }),
								className: 'form-control'
							})}
						/>
						<div className="autocomplete-dropdown-container ">
							{loading && <div>Loading...</div>}
							{suggestions.map(suggestion => {
								const className = suggestion.active ? 'suggestion-item--active py-1 px-2' : 'suggestion-item py-1 px-2';
								// inline style for demonstration purpose
								const style = suggestion.active
									? { backgroundColor: '#fafafa', cursor: 'pointer' }
									: { backgroundColor: '#ffffff', cursor: 'pointer' };
								return (
									<div
										{...getSuggestionItemProps(suggestion, {
											className,
											style
										})}
									>
										<span>{suggestion.description}</span>
									</div>
								);
							})}
						</div>
					</div>
				)}
			</PlacesAutocomplete>
		);
	}
}

LocationSearchInput.propTypes = {
	intl: intlShape.isRequired
};

export default injectIntl(LocationSearchInput);



// WEBPACK FOOTER //
// ./components/LocationSearchInput/index.js